import {CurrentUserService} from "../../../../services/user/CurrentUserService";
import {UserStripeService} from "../../../../stripe/service/UserStripeService";
import {ClientDashboardModel} from "../../models/ClientDashboardModel";
import {StripeProductName} from "../../../../stripe/models/StripeProductNames";
import {ClientDashboardModelProvider} from "../ClientDashboardModelProvider";
import {IInvestProductMappings, IInvestStoreProduct} from "../../../../store/iinvest/models/IInvestStoreProduct";
import {FeatureNames} from "../../../../types/UserConfig";

export class IInvestClientDashboardModelProvider extends ClientDashboardModelProvider {

    public static id = "iinvestClientDashboardModelProvider";

    /** @ngInject */
    public constructor(private readonly currentUserService: CurrentUserService,
                       private readonly userStripeService: UserStripeService) {
        super();
    }

    public async model(): Promise<ClientDashboardModel> {
        const productHistory = await this.userStripeService.productHistory();
        const portfolio = this.activeFeature();

        const strategyBuilder = this.buildFeatureStatus(StripeProductName.PLATFORM, productHistory);
        const charting = this.buildFeatureStatus(StripeProductName.PLATFORM, productHistory);
        const backtesting = this.hiddenFeature();

        const billing = await this.userStripeService.billingDetails();
        const card = billing.card;

        return {
            showMarginLimit: false,
            showHelp: false,
            showTradingIdeas: false,
            showMarketSummary: false,
            openCmaDeposit: null,
            hasTradingAlerts: this.currentUserService.hasFeature(FeatureNames.TRADING_ALERTS),

            features: {
                hasBillingDetails: card != null,
                portfolio,
                charting,
                strategyBuilder,
                backtesting
            }
        };
    }

    protected storeUrl(name: StripeProductName): string | null {
        switch (name) {
            case StripeProductName.PLATFORM:
                return `store?product=${IInvestStoreProduct.PLATFORM}`;
            default:
                return null;
        }
    }

    protected trialPeriod(name: StripeProductName): number {
        switch (name) {
            case StripeProductName.PLATFORM:
                return IInvestProductMappings.PLATFORM.trial;
            default:
                return 0;
        }
    }
}
